import { createApi } from "@reduxjs/toolkit/query/react";
import MAIN_PATHS from "src/business.InterfaceLayer/store/mainPaths";
import baseQueryWithReAuth from "src/business.InterfaceLayer/store/services/utils.service/baseQueryWithReAuth";
import userApiGetQueries from "./endpoints/GET";
import userApiPostQueries from "./endpoints/POST";
import userApiPutQueries from "./endpoints/PUT";
import userApiDeleteQueries from "./endpoints/DELETE";

export const userApi = createApi({
	baseQuery: baseQueryWithReAuth,
	reducerPath: `${MAIN_PATHS.USER}Api`,
	tagTypes: [`${MAIN_PATHS.USER}TAG`],
	endpoints: (build) => ({
		...userApiGetQueries(build),
		...userApiPostQueries(build),
		...userApiPutQueries(build),
		...userApiDeleteQueries(build),
	}),
});

export const {
	useGetUsersQuery,
	useLazyGetUsersQuery,
	useGetUsersCountQuery,
	useGetUsersManagersQuery,
	usePostUserCreateMutation,
	usePostUserStatusUpdateMutation,
	usePutUserChangeCoordinationMutation,
	usePutUserEditMutation,
	useDeleteUserDeleteMutation,
	useGetUserIDQuery,
	useLazyGetUserIDQuery,
	useLazyGetUserRequestPasswordIDQuery,
	usePutUserRecoveryPasswordMutation,
	useGetUsersRequestPasswordCountQuery,
	useGetUsersRequestPasswordQuery,
	usePutUserChangePasswordRequestMutation,
	useLazyGetUsersRequestPasswordQuery,
	usePutUserChangeAvatarMutation,
	useLazyGetProfileQuery,
	useGetProfileQuery,
} = userApi;
